import { getLanguage } from '../../store/translations/hooks';
import { SubscriptionAddonTier } from '../../models';

const getLocale = () => (getLanguage() === 'pt' ? 'pt-PT' : 'en-US');

// Note: Currency is hardcoded to EUR as it's not currently available in the API response.
// TODO: Get currency from SubscriptionDataResponse or company settings when available
export const formatCurrency = (value: number, currency: string = 'EUR') =>
    new Intl.NumberFormat(getLocale(), {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
    }).format(value);

export const getAddonTierPrice = (tier: SubscriptionAddonTier, billingPeriod: 'monthly' | 'yearly') =>
    billingPeriod === 'yearly'
        ? tier.pricePerMonthBilledAnnually ?? tier.pricePerMonth
        : tier.pricePerMonthBilledMonthly ?? tier.pricePerMonth;

export const formatDateLocalized = (
    value: string | Date | null | undefined,
    fallback: string
) => {
    if (!value) return fallback;
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return fallback;

    return date.toLocaleDateString(getLocale(), {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};
